import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@utils/auth' // get token from cookie

const whiteList = ['/register', '/login', '/loginmeter', '/privacy-policy']
NProgress.configure({ showSpinner: false }) // 设置 NProgress
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/home' })
    } else {
      next()
    }
  } else {
    if (whiteList.includes(to.path) || to.path.includes('bigscreen') || to.path.includes('mbigscreen')) {
      next()
    } else {
      next({ path: '/login' }) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  document.title = to.meta.title
  NProgress.done()
})
